import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/accessibility/fr/accessibility_EN.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Accessibility/accessibility__en-GB.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-GB'].layout },
  seo: {
    title: 'Accessibility - Lemonade Insurance UK',
    metaTitle: 'Accessibility - Lemonade Insurance UK',
    description: 'Lemonade is committed to making our website’s content accessible and user-friendly to everyone.',
    ogImage: og.src,
  },
  MDXContent: content as DocumentTypes,
};
